import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { MdLocalShipping } from 'react-icons/md';
import { LocaleContext } from '@rsc/contexts/LocaleContext';
import { SiteSettingsContext } from '@rsc/contexts/SiteSettingsContext';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';
import { useInternationalContext } from '@rsc/gatsby-localization-helpers';

import sharedStyles from '../styles';

const StyledContainer = styled.div`
  padding: ${sharedStyles.spacing['spacing-md']};
  background: ${({ theme }) => theme.colors.brandPrimary};
  color: ${({ theme }) => theme.colors.typography.brandContrast};
  display: flex;
  gap: ${sharedStyles.spacing['spacing-1xs']};
  align-items: center;
  font-size: ${sharedStyles.fontSize.sm};
  font-weight: ${sharedStyles.fontWeight.bold};
`;

const FREE_SHIPPING_DISABLED_FOR = ['en-au'];

function ShippingPromo({ cartTotal, hasSubscriptionItems }) {
  const localeContext = useContext(LocaleContext);
  const { tt, localizePrice } = useUiComponentsInternationalContext();
  const { locale } = useInternationalContext();
  const { siteSettings } = useContext(SiteSettingsContext);
  const { shipping } = siteSettings;

  const currency = localeContext?.currency || 'USD';
  const threshold = parseFloat(shipping);

  // Disable Free Shipping banner for provided list of locales
  // or if threshold is not set
  if (!threshold || FREE_SHIPPING_DISABLED_FOR.includes(locale)) return null;

  const remainingAmount = threshold - cartTotal;

  let message;

  if (cartTotal >= threshold || hasSubscriptionItems) {
    message = tt(s => s.cartCommon.orderQualifiesForFreeShippingMessage);
  } else {
    const price =
      currency === 'CAD'
        ? `CA$${remainingAmount.toFixed(2)}`
        : localizePrice(remainingAmount);
    message = tt(s => s.cartCommon.closeToFreeShippingMessage, {
      price,
    });
  }

  return (
    <StyledContainer>
      <MdLocalShipping size={28} />
      <span>{message}</span>
    </StyledContainer>
  );
}

ShippingPromo.propTypes = {
  cartTotal: PropTypes.string.isRequired,
  hasSubscriptionItems: PropTypes.bool.isRequired,
};

export default ShippingPromo;
